<template>
<div class="page-container" v-loading="isLoading"> 
  <div class="search-box">
    <div class="flex-row search-main">
      <el-popover
        popper-class="search-popover"
        placement="bottom"
        width="628"
        v-model="showSearchPopover"
        trigger="click">
        <div class="history-popup">
          <div class="search-popver__title">
            <span>搜索历史</span>
            <span class="clear-btn" v-if="historyList.length" @click="clearHistoryDialog = true"><i class="el-icon-delete"></i>清除</span>
          </div>
          <div :class="['search-popver__content', 'history-content', historyExpanded ? 'is-expanded' : '']" v-if="historyList.length" ref="historyContent">
            <div class="history-items" ref="historyItems">
              <div class="item" v-for="(item, index) in historyList" @click="historyItemClick(item)" :key="index">{{ item }}</div>
            </div>
            <div class="expand-btn" v-if="historyOverflow && !historyExpanded" @click="historyExpanded = true"><i class="el-icon-arrow-down"></i></div>
            <div class="expand-btn" v-if="historyExpanded" @click="historyExpanded = false"><i class="el-icon-arrow-up"></i></div>
          </div>
          <div class="search-popver__content" v-else>
            <div class="no-data" style="padding: 0; font-size: 12px;">暂无搜索历史</div>
        </div>
        </div>
        <div class="input-btn flex-row" slot="reference">
          <el-input style="width: 600px;" placeholder="请输入品类/品牌/机制/商品名称/报单ID" v-model="keyword" />
          <el-button class="search-btn" @click="getList">搜索</el-button>
        </div>
      </el-popover>
    </div>
    <!-- <div class="tags-box">
      <span class="tag" v-for="tag in tags" :key="tag" @click="selectTag(tag)">{{ tag }}</span>
    </div> -->
  </div> 

  <div class="flex-row flex-main-axis-between back-container">
    <div class="flex-row flex-secondary-axis-center">
      <div class="back" @click="$router.back()">
        <i class="el-icon-arrow-left"></i>返回
      </div>
      <div class="no-data-tip" v-if="!(list.length && !isLoading)">抱歉，没有找到相关直播间口令链接</div>
    </div>

    <!-- <el-button icon="el-icon-document-copy" style="padding: 3px 16px !important;" @click="showBatchCopyDialog = true" class="promary-btn-sup" v-if="(list.length && !isLoading)">搜索结果 · 一键复制</el-button> -->
  </div>

  <div class="cards-container" v-if="list.length && !isLoading">
    <div class="item" v-for="(item, index) in list" :key="index">
      <ProductCard :product="item" :roleType="roleType" @toReserve="toReserve(item)" />
    </div>
  </div>
  <div v-else class="no-data">
    <div>
      <img src="../../../../../../assets/images/no-data.png" style="width: 236px; height: 200px;" />
    </div>
    <div>关键词：{{ keyword }}</div>
    <div>选品库搜索无结果。我现在需要，请工作人员尽快安排！谢谢！</div>
    <el-button class="promary-btn-sup" @click="notifyWorker" style="width: 200px; margin: 12px auto;">通知群内工作人员</el-button>
  </div>
  <!-- <div class="page-pagination">
    <el-pagination
      v-if="pageInfo.total > 0"
      class="d-ib"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total"
      :page-size="pageInfo.pageSize"
      :page-sizes="pageInfo.sizes"
      :current-page="pageInfo.pageIndex"
      @current-change="pageInfo.pageIndex = arguments[ 0 ], getList()"
      @size-change="pageInfo.pageSize = arguments[ 0 ]; pageInfo.pageIndex = 1; getList()">
    </el-pagination>
  </div> -->

  <BaseDailog v-if="showBatchCopyDialog" v-model="showBatchCopyDialog" width="512px" :showCancel="false" @confirm="copyHandler"
    title="提示"
    confirmText="点击复制" 
  >
    <div class="copy-content">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div>直播间：{{ item.liveRoomName || '-' }}</div>
        <div>口令：{{ computedSignalPass(item.signalPass) }}</div>
        <div>爆品限时补贴至：{{ item.h5Show == 1 ? (item.userRebateStr || 0) : '-'}}</div>
      </div>
    </div>
  </BaseDailog>

  <BaseDailog v-if="copySuccessTipDialog" v-model="copySuccessTipDialog" width="414px" :showCancel="false" @confirm="copySuccessTipDialog = false"
    title="文案复制成功"
    confirmText="确定" 
    icon="success"
    sourceType="sup"
  >
    <div class="copy-content-tip">
      <div>关键词：植村秀</div>
      <div>选品库搜索无结果。我现在需要，请工作人员尽快安排！谢谢！</div>
    </div>
  </BaseDailog>

  <BaseDailog v-if="showCopyDialog" v-model="showCopyDialog" width="512px" :showCancel="false" @confirm="copyKLFn"
    title="复制口令"
    confirmText="点击复制"
  >
    <div v-if="curRow" class="copy-content">
      <div>直播间：{{ curRow.liveRoomName }}</div>
      <div>品类：{{ curRow.categoryName }}</div>
      <div>品牌：{{ curRow.brandName }}</div>
      <div v-if="curRow.h5Show == 1 && curRow.signalPass && curRow.backendCommission">
        <div>失效时间：{{ computedTime(curRow.validEndTime) }}</div>
        <div>口令：{{ extractUrls(curRow.signalPass) }}</div>
        <div>爆品限时补贴至：{{ curRow.userRebateStr || 0 }}</div>
      </div>
      <div v-else style="margin-top: 20px;">
        选品库暂无有效口令。我现在需要，请工作人员尽快安排！谢谢！
      </div>
    </div>
  </BaseDailog>


  <BaseDailog v-if="showCopyDialog" v-model="showCopyDialog" width="512px" :showCancel="false" @confirm="copyKLFn"
    title="复制口令"
    confirmText="点击复制"
  >
    <div v-if="curRow" class="copy-content">
      <div>直播间：{{ curRow.liveRoomName }}</div>
      <div>品类：{{ curRow.categoryName }}</div>
      <div>品牌：{{ curRow.brandName }}</div>
      <div v-if="curRow.h5Show == 1 && curRow.signalPass && curRow.backendCommission">
        <div>失效时间：{{ computedTime(curRow.validEndTime) }}</div>
        <div>口令：{{ extractUrls(curRow.signalPass) }}</div>
        <div>爆品限时补贴至：{{ curRow.userRebateStr || 0 }}</div>
      </div>
      <div v-else style="margin-top: 20px;">
        选品库暂无有效口令。我现在需要，请工作人员尽快安排！谢谢！
      </div>
    </div>
  </BaseDailog>

  <BuyDrawer v-model="showBuyDrawer" @toOrder="toOrder" :product="curRow" />

  <OrderReserveDrawer v-model="showOrderReserveDrawer" :product="curRow" @success="getList" />

  <AddReportDialog
    v-if="showAddReportDialog"
    v-model="showAddReportDialog"
    :roleType="roleType"
    :product="curRow"
    @check-result="checkResultCb"
    @close="showAddReportDialog = false"
    @on-success="showAddResultDialogHandler"
  />

  <!-- 检查结果弹框 -->
  <CheckResultDialog
    v-if="showCheckResultDialog"
    v-model="showCheckResultDialog"
    :rst="checkResult"
    @close="showCheckResultDialog = false" />

  <AddResultDialog
    v-if="showAddResultDialog"
    v-model="showAddResultDialog"
    :importResult="importResult"
    :roleType="roleType"
    @close="showAddResultDialog = false; importResult = {}"
    @on-success="showAddResultDialog = false"
  />

  <BaseDailog v-if="clearHistoryDialog" v-model="clearHistoryDialog" width="512px" @cancel="showSearchPopover = true; clearHistoryDialog = false;" sourceType="sup" @confirm="clearHistory" title="提示">
    <div class="clear-content">确定要删除所有历史记录吗？</div>
  </BaseDailog>
</div>
</template>

<script>
import BaseDailog from '@/page/component/sections/base-dailog'
import ProductCard from '@/page/component/sections/xpk/sup/product-card'
import BuyDrawer from '@/page/component/sections/xpk/sup/buy-drawer'
import OrderReserveDrawer from '@/page/component/sections/xpk/sup/order-reserve-drawer'
import AddReportDialog from '@/page/component/sections/order/sup-add-report-dialog.vue'
import CheckResultDialog from '@/page/component/sections/order/check-result-dialog.vue'
import AddResultDialog from '@/page/component/sections/order/sup-add-result-dialog.vue'
import {
  getKlHotSearchWord
} from '@/service/apis/kl'
import { getQdVolumeProductList } from '@/service/apis/supVolume'
import { getAccountRoleType } from '@/service/apis/order'
import { addBatchBuryingPoint, addBuryingPoint } from '@/service/apis/common'
import moment from 'moment'
import { copyFn } from '@/utils/util'
import { getUserId } from '@/utils/getUser'

export default {
  components: {
    BaseDailog,
    ProductCard,
    BuyDrawer,
    OrderReserveDrawer,
    AddReportDialog,
    CheckResultDialog,
    AddResultDialog
  },
  name: 'XpkM2sSearch',
  data() {
    return {
      clearHistoryDialog: false,
      historyExpanded: false,
      historyOverflow: false,
      historyList: [],
      keyword: '',
      tags: [],
      pageInfo: {
        pageIndex: 1,
        pageSize: 2000,
        sizes: [ 10, 20, 30, 50, 100 ],
        total: 0
      },
      list: [],
      isLoading: false,
      copySuccessTipDialog: false,
      curRow: null,
      showBatchCopyDialog: false,
      showCopyDialog: false,
      tip: '选品库搜索无结果。我现在需要，请工作人员尽快安排！谢谢！',
      showBuyDrawer: false,
      showOrderReserveDrawer: false,
      showAddReportDialog: false,
      roleType: null,
      checkResult: null,
      showCheckResultDialog: false,
      showQueryBdRebateInfoDialog: false,
      showAddResultDialog: false
    }
  },
  watch: {
    showSearchPopover (val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => this.checkHistoryOverflow(), 50)
        })
      }
    }
  },
  async created () {
    await this.getAccountRoleType()
    this.getKlHotSearchWord()
    if (this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword
    }

    const history = window.localStorage.getItem('SUP_HISTORY_SEARCH')
    if (history) {
      this.historyList = JSON.parse(history)
    }
    this.getList()
  },
  methods: {
    clearHistory () {
      this.historyList = []
      window.localStorage.setItem('SUP_HISTORY_SEARCH', JSON.stringify(this.historyList))
    
      this.clearHistoryDialog = false
    },
    historyItemClick (tag) {
      this.updateHistoryList(tag)
      this.keyword = tag
      this.getList()
    },
    updateHistoryList (tag) {
      if (this.historyList.includes(tag)) {
        this.historyList = this.historyList.filter(item => item !== tag)
      }
      this.historyList.unshift(tag)
      window.localStorage.setItem('SUP_HISTORY_SEARCH', JSON.stringify(this.historyList))
      this.$nextTick(() => this.checkHistoryOverflow())
    },
    checkHistoryOverflow () {
      const el = this.$refs.historyItems
      if (el) {
        this.historyOverflow = el.scrollHeight > 76
      }
    },
    getAccountRoleType () {
      const accountId = getUserId()
      getAccountRoleType.call(this, {
        accountId // getUserId()
      }).then(res => {
        if (res) {
          this.roleType = res 
        }
      })
    },
    computedTime (date) {
      if (date) {
        return moment(date).format('YYYY/MM/DD HH:mm:ss')
      }
      return '-'
    },
    extractUrls (text) {
      const urlRegex = /weixin?:\/\/[^\s]+/i;
      let match = text.match(urlRegex);
      if (match) {
        return match[0].trim()
      }
      return ''
    },

    showAddResultDialogHandler (rst) {
      this.showAddReportDialog = false
      this.importResult = rst
      this.showAddResultDialog = true
    },
    toOrder (row) {
      // this.curRow = row
      this.showAddReportDialog = true
    },
    toBuy (row) {
      console.log(row)
      this.curRow = row
      this.showBuyDrawer = true
    },
    toReserve (row) {
      this.curRow = row
      this.showOrderReserveDrawer = true
    },
    copyContent (row) {
      this.curRow = row
      this.showCopyDialog = true
    },
    copyKLFn () {
      const data = this.curRow || {}
      let copyContent = this.isValid(data) ? `直播间：${data.liveRoomName}\n品类：${data.categoryName}\n品牌：${ data.brandName }\n失效时间：${ this.computedTime(data.validEndTime) }\n口令：${ this.extractUrls(data.signalPass) }\n爆品限时补贴至：${ data.userRebateStr || 0 }` 
          : `直播间：${data.liveRoomName}\n品类：${data.categoryName}品牌：${ data.brandName }\n选品库暂无有效口令。我现在需要，请工作人员尽快安排！谢谢！`
      copyFn(copyContent, () => {
        this.showCopyDialog = false
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      })
      addBuryingPoint.call(this, {
        type: 2,
        liveRoomId: data.liveRoomId || '',
        liveRoomName: data.liveRoomName || '',
        copyContent: JSON.stringify({
          mainImage: data.mainImage,
          liveRoomName: data.liveRoomName,
          productName: data.productName,
          copyContent
        }, false, false)
      })
    },
    notifyWorker () {
      copyFn(`关键词：${this.keyword}\n${this.tip}`, () => {
        // this.$message.success('复制成功')
        this.copySuccessTipDialog = true
        // "类型 1-登录 2-复制 3-搜索 4-搜索不结果反馈")
        addBuryingPoint.call(this, {
          type: 4,
          searchContent: this.keyword
        })
      })
    },
    computedSignalPass (text) {
      if (!text) return '-'
      // return str.split(' ')[0]
      const urlRegex = /weixin?:\/\/[^\s]+/i;
      let match = text.match(urlRegex);
      if (match) {
        return match[0].trim()
      }
    },
    copyHandler () {
      let itemArr = []
      this.list.forEach(data => {
        let copyContent  = this.isValid(data) ? `直播间：${data.liveRoomName}\n口令：${ this.computedSignalPass(data.signalPass) }\n爆品限时补贴至：${ (data.userRebateStr || 0) }`
            : `直播间：${data.liveRoomName}\n品类：${data.categoryName}\n品牌：${ data.brandName }\n选品库暂无有效口令。我现在需要，请工作人员尽快安排！谢谢！`
        itemArr.push(copyContent)
        // buryingPointList.push({
        //     type: 2,
        //     liveRoomId: data.liveRoomId || '',
        //     liveRoomName: data.liveRoomName || '',
        //     copyContent: JSON.stringify({
        //       mainImage: data.mainImage,
        //       liveRoomName: data.liveRoomName,
        //       productName: data.productName,
        //       copyContent
        //     })
        //   })
      })
      // itemArr.join('\n\n'),
      // 复制内容
      copyFn(itemArr.join('\n\n'), () => {
        this.showBatchCopyDialog = false
        this.$message.success('复制成功')
      })
    },
    isValid (data) {
      if (data.h5Show == 0 || (!data.signalPass && !data.backendCommission)) { 
        return false
      }
      if (data.validEndTime) {
        const now = moment()
        const validEndTime = moment(data.validEndTime)
        return now.isBefore(validEndTime)
      }
      return false
    },
    selectTag (tag) {
      this.keyword = tag
      this.getList()
    },
    async getKlHotSearchWord () {
      const res = await getKlHotSearchWord.call(this)
      this.tags = (res || []).map(item => item.word)
    },
    getList () { 
      const opt = {}
      if (this.keyword) {
        opt.keyword = this.keyword
        this.updateHistoryList(this.keyword)
      }
      this.isLoading = true
      getQdVolumeProductList.call(this, opt).then(res => {
        const products = res || []
        this.list = products
        this.pageInfo.total = products.length
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
.search-main,
.tags-box {
  padding: 12px 0 0 0;
  width: 720px;
  margin: 0 auto;
}
.tags-box {
  color: #6A6A6A;
}
.tags-box .tag {
  cursor: pointer;
  font-size: 13px;
  margin-right: 12px;
}
.input-btn {
  border: solid 1px #9266FF;
  padding: 1px;
  border-radius: 4px;
}
.input-btn ::v-deep .el-input__inner {
  border: none;
}
.input-btn .search-btn {
  padding: 0 12px;
  border: 1px solid;
  color: #fff;
  background: linear-gradient(270deg, #9A63FF 0%, #FF48D3 100%); 
}

.line-tabs {
  cursor: pointer;
  display: flex;
  color: rgba(0, 0, 0, 0.6);
  position: relative;
  height: 24px;
  font-size: 14px;
  font-weight: 500x;
  line-height: 24px;
}
.line-tabs::after {
  content: '';
  position: absolute; 
  bottom: 1px;
  height: 1px;
  width: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.1);
}
.line-tabs .item {
  margin-right: 24px;
  position: relative;
}
.line-tabs .item.active,
.line-tabs .item:hover {
  color: #9A63FF;
}
.line-tabs .item.active::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  border-radius: 3px;
  background-color: #9A63FF;
  z-index: 2;
}
.cards-container {
  padding: 16px 0;
  display: flex;
  flex-wrap: wrap;
}
.cards-container .item {
  width: calc((100% - (24px * 4)) / 5);
  margin: 0 24px 24px 0;
}
.cards-container .item:nth-child(5n) {
  margin-right: 0;
}
.page-pagination {
  text-align: center;
  padding-bottom: 24px;
}
.no-data {
  display: flex;
  flex-direction: column;
  padding: 24px 0;
  line-height: 32px;
  text-align: center;
  font-size: 16px;
  color: #999;
}
.back-container {
  padding: 16px 12px 0 12px;
}
.back {
  display: inline-block;
  padding: 0 12px;
  cursor: pointer;
  border: solid 1px rgba(134, 134, 134, 1);
  border-radius: 4px;
  height: 32px;
  line-height: 32px;
  margin-right: 12px;
}
.no-data-tip {
  color: rgba(88, 88, 88, 1);
  font-size: 16px;
}
.search-types {
  padding: 12px;
  padding-bottom: 0;
  background-color: #fff;
}
::v-deep .el-dialog__body {
  padding-top: 0;
}
.copy-content {
  max-height: 400px;
  overflow: scroll;
  padding-top: 16px;
  line-height: 26px;
  border-top: solid 1px rgba(229, 229, 229, 1);
}
.copy-content .item {
  color: rgba(88, 88, 88, 1);
  padding-bottom: 8px;
}
.copy-content-tip {
  padding-top: 16px;
  border-top: solid 1px rgba(229, 229, 229, 1);
  color: rgba(88, 88, 88, 1);
  line-height: 24px;
}
.copy-content-tip div {
  padding-bottom: 4px;
}
.search-popver__title {
  line-height: 20px;
  color: rgba(47, 47, 47, 1);
  font-weight: 400;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.search-popver__content {
  padding: 6px 0 16px 0;
  display: flex;
  flex-wrap: wrap;
}
.search-popver__content .item {
  font-size: 12px;
  color: rgba(100, 100, 100, 1);
  border: solid 0.5px rgba(218, 218, 218, 1);
  line-height: 32px;
  padding: 0 12px;
  border-radius: 18px;
  margin: 0 16px 6px 0;
  cursor: pointer;
  transition: all 0.3s;
}
.search-popver__content .item:hover {
  background-color: #9266FF;
  color: #fff;
}
.clear-btn {
  color: rgba(100, 100, 100, 1);
  font-size: 12px;
  cursor: pointer;
}
.clear-btn i {
  margin-right: 3px;
}
.clear-btn:hover {
  color: #9266FF;
}
.clear-content {
  font-size: 16px;
  text-align: center;
  padding-bottom: 24px;
}
.history-content {
  position: relative;
  padding-right: 24px;
}
.history-content .history-items {
  display: flex;
  flex-wrap: wrap;
  max-height: 76px;
  overflow: hidden;
}
.history-content.is-expanded .history-items {
  max-height: none;
}
.history-content .expand-btn {
  position: absolute;
  right: 0;
  bottom: 6px;
  cursor: pointer;
  color: #999;
  font-size: 14px;
  line-height: 32px;
}
.history-content .expand-btn:hover {
  color: #9266FF;
}
</style>
